import { render } from "./HapiacaMailMagazineConfirm.vue?vue&type=template&id=7ba0cc92&ts=true"
import script from "./HapiacaMailMagazineConfirm.vue?vue&type=script&lang=ts"
export * from "./HapiacaMailMagazineConfirm.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1253990065/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__